import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "mx-auto",
  viewBox: "0 0 42 42"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#7366DB",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2.85",
      d: "m12.45 21 5.7 5.7 11.4-11.4M40 21c0 10.493-8.507 19-19 19S2 31.493 2 21 10.507 2 21 2s19 8.507 19 19"
    }, null, -1)
  ])))
}
export default { render: render }